import React from "react";
import { useParams, Link } from "react-router-dom";
import { CATEGORIES, getToolsByCat } from "../lib/tools";
import ToolCard from "../components/ToolCard";
import Seo from "../components/Seo";
import AdSlot from "../components/AdSlot";
import { ArrowLeft } from "lucide-react";

export default function Category() {
  const { id } = useParams();
  const cat = CATEGORIES.find((c) => c.id === id);
  if (!cat) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      {cat && (
        <Seo
          title={`${cat.label} — Free Online Tools | ToolHaus`}
          description={`Free ${cat.label.toLowerCase()} that run in your browser. No signup, no watermarks, no limits.`}
          path={`/category/${cat.id}`}
        />
      )}
        <p className="text-gray-500">Category not found.</p>
        <Link to="/" className="text-primary hover:underline mt-3 inline-block">Back to all tools</Link>
      </div>
    );
  }
  const tools = getToolsByCat(id);
  const Icon = cat.icon;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Link to="/" className="text-sm text-gray-500 hover:text-primary inline-flex items-center gap-1 mb-8" data-testid="back-home">
        <ArrowLeft size={14} /> All tools
      </Link>
      <div className="flex items-center gap-4 mb-3">
        <div className="h-12 w-12 rounded-lg flex items-center justify-center" style={{ background: `${cat.accent}14`, color: cat.accent }}>
          <Icon size={22} strokeWidth={1.75} />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] font-semibold text-gray-400">Category</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold">{cat.label}</h1>
        </div>
      </div>
      <p className="text-gray-500 max-w-2xl mt-3">{tools.length} tools, all free and instant. No accounts.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {tools.map((t, i) => <ToolCard key={t.slug} tool={t} index={i} />)}
      </div>

      <div className="mt-14">
        <AdSlot variant="leaderboard" testid="ad-category-bottom" />
      </div>
    </div>
  );
}
